export const loadingSelector = (state) => {
  return (
    state.chat.loading &&
    state.members.loading &&
    state.organizations.loading &&
    state.clients.loading &&
    state.analytics.loading
  );
};
